import React, { useState, useMemo } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Snackbar from '@mui/material/Snackbar'
import Slide from '@mui/material/Slide'

import Header from './components/Header'
import EmployerMessagingRegistration from './components/Header/EmployerMessagingRegistration'
import ImpersonationBanner from './components/Impersonation/ImpersonationBanner'
import Routes from './pages/Routes'
import PullToRefresh from './components/PullToRefresh'
import ThemeRoot from './ThemeRoot'
import LoadingContext from './LoadingContext'

function App() {
  const [isLoading, setIsLoading] = useState(false)
  const loadingContext = useMemo(() => ({
    open() { setIsLoading(true) },
    close() { setIsLoading(false) }
  }), [])

  return (
    <ThemeRoot>
      <Snackbar
        anchorOrigin={snackbarAnchorOrigin}
        open={isLoading}
        message="טוען ..."
        TransitionComponent={TransitionDown}
      />
      <BrowserRouter
        basename={basename}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <EmployerMessagingRegistration />
        {/* #380 §5 — the permanent impersonation indicator, route-independent
            like EmployerMessagingRegistration above, and mounted before
            Header so it renders above it (the design calls for "above every
            route", not merely inside the toolbar). Renders nothing outside
            an active session — see the component's own no-session guard. */}
        <ImpersonationBanner />
        {/* #204's Samsung notice is app-level (it belongs to no single screen)
            and lives inside Header, under the toolbar — see Header.js. */}
        <Header/>
        <PullToRefresh>
          <LoadingContext.Provider value={loadingContext}>
            <Routes/>
          </LoadingContext.Provider>
        </PullToRefresh>
      </BrowserRouter>
    </ThemeRoot>
  )
}

export default App

const snackbarAnchorOrigin = {
  vertical: 'top',
  horizontal: 'center',
}

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

const basename = process.env.NODE_ENV === 'production' &&
  window.location.hostname === 'kravetzky.github.io' ?
  '/salary-calculator' : undefined
console.debug('basename:', basename)
